import { createFileRoute, redirect } from '@tanstack/react-router'

// Legacy redirect — tags management/browse was consolidated under
// `/$org/settings/tags` (see specs/todos/2026-07-20-02-move-tags-management-into-settings.md).
// Kept so old bookmarks/deep links keep working.
export const Route = createFileRoute('/$org/tags/')({
    beforeLoad: ({ params }) => {
        throw redirect({ to: '/$org/settings/tags', params })
    },
})
